{
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.10.0",
    "@stackwright/cli": "^0.9.0",
    "@stackwright-pro/auth-nextjs": "workspace:*",
    "@stackwright-pro/emitters": "workspace:*",
    "@stackwright-pro/cli-data-explorer": "workspace:*",
    "@stackwright-pro/openapi": "workspace:*",
    "@stackwright-pro/pulse": "workspace:*",
    "@stackwright-pro/telemetry": "workspace:*",
    "@stackwright-pro/types": "workspace:*",
    "@stackwright/mcp": "0.6.0-alpha.2",
    "@types/js-yaml": "^4.0.9",
    "js-yaml": "^4.2.0",
    "proper-lockfile": "^4.1.2",
    "zod": "^4.4.3"
  },
  "devDependencies": {
    "@types/node": "catalog:",
    "@types/proper-lockfile": "^4.1.4",
    "tsup": "catalog:",
    "typescript": "catalog:",
    "vitest": "catalog:"
  },
  "scripts": {
    "prepublishOnly": "node scripts/verify-integrity-sync.js",
    "build": "tsup",
    "dev": "tsup --watch",
    "start": "node dist/server.js",
    "test": "vitest run",
    "test:coverage": "vitest run --coverage"
  },
  "name": "@stackwright-pro/mcp",
  "version": "0.2.0-alpha.108",
  "description": "MCP tools for Stackwright Pro - Data Explorer, Security, ISR, and Dashboard generation",
  "license": "SEE LICENSE IN LICENSE",
  "main": "./dist/server.js",
  "bin": {
    "stackwright-pro-mcp": "./dist/server.js"
  },
  "module": "./dist/server.mjs",
  "types": "./dist/server.d.ts",
  "exports": {
    ".": {
      "types": "./dist/server.d.ts",
      "import": "./dist/server.mjs",
      "require": "./dist/server.js"
    },
    "./integrity": {
      "types": "./dist/integrity.d.ts",
      "import": "./dist/integrity.mjs",
      "require": "./dist/integrity.js"
    },
    "./type-schemas": {
      "types": "./dist/tools/type-schemas.d.ts",
      "import": "./dist/tools/type-schemas.mjs",
      "require": "./dist/tools/type-schemas.js"
    },
    "./pipeline-constants": {
      "types": "./dist/pipeline-constants.d.ts",
      "import": "./dist/pipeline-constants.mjs",
      "require": "./dist/pipeline-constants.js"
    }
  },
  "files": [
    "dist"
  ],
  "publishConfig": {
    "access": "public"
  }
}
